<div class="EXTRA_SERVICE_CAR_RENTAL_FORM modal-header w-100 d-inline-block border-bottom pb-0 mb-0">
    <div class="d-flex justify-content-between">
      <h4 class="booking-modal-title">Car Rental</h4>
      <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
    </div>
    <div>
    </div>
  </div>
  <div class="modal-body p-4 mt-3">
   <p class="my-3 intro">Our team are available on the go to assist & support with your Car Rental request.</p>
    <form [formGroup]="form">
        <div class="form-group mb-3">
            <div class="row">
                <label class=" form-label ">
                  Pick-up Location <span class="text-danger">*</span>
                </label>
                
                <div class="col-12 form-input">
                    <app-location-selector className="input-locator" placeholder="Enter location where rental car will be picked Up" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeF($event)">
                  </app-location-selector>
                </div>
                <div class="col-12 form-input ">
            <label class=" form-label ">
                  Drop-off Location <span class="text-danger">*</span>
                </label>
                    <app-location-selector className="input-locator" placeholder="Enter location where rental car will be dropped off" [showErrorMsg]="false"
                    [showExample]="false" [showPrefixPadding]="false" [showPrefixIcon]="false"
                    (values)="locationChangeT($event)">
                  </app-location-selector>
                </div>
               
              </div>
        </div>
        <div class="form-group mb-3">
            <label class=" form-label ">
              Rental Dates <span class="text-danger">*</span>
            </label>
            <div class="row">
                <div class="col-6 form-input">
                    <app-input [min]="minDate" formCtrlName="rental_start_date" [label]="'Date'" [formGrp]="form" date [required]="true">
                    </app-input>
                </div>
                <div class="col-6 form-input ">
            
                    <app-input [min]="minDate" formCtrlName="rental_end_date" [label]="'Date'" [formGrp]="form" date [required]="true">
                    </app-input>
                </div>
               
              </div>
        </div>
        
        <div class="col-12 form-input mb-3">
            <label class="mt-2 form-label ">
             Vehicle Type <span class="text-danger">*</span>
            </label>
            <select class="form-control" formControlName="car_type" name="" id="">
                <option value="">Select requested vehicle type</option>
                <option value="compact">Compact</option>
                <option value="suv">SUV</option>
                <option value="luxury-vehicle">Luxury Vehicle</option>
            </select>
        </div>
        <div class="mb-3 ">
           
            <label class="mt-2 form-label form-toggle">
              Additional Request
            </label>
            <textarea formControlName="additional_requests" placeholder="Any special requests or preferences, such as child seat's or GPS navigation*" class="form-control form-input booking-text-area text-body"
              cols="10" rows="5"></textarea>
        
            
        </div>
        <app-button 
                    class="book-btn"
                    [disabled]="form.invalid"
                    (click)="submit()"
                    [className]="'w-100'" warning>
                    {{loading ? 'Loading...': 'Submit'}}
                  </app-button>
    </form>


  </div>
  